import React from 'react';
import styles from './Frame.module.css';

export interface FrameProps {
  caption?: string;
  children?: React.ReactNode;
  className?: string;
}

export const Frame: React.FC<FrameProps> = ({ caption, children, className = '' }) => {
  return (
    <figure className={`${styles.frame} ${className}`.trim()}>
      <div className={styles.inner}>{children}</div>
      {caption && <figcaption className={styles.caption}>{caption}</figcaption>}
    </figure>
  );
};

export default Frame;
